import React from "react";
import { MapPin, Calendar, Clock, Edit } from "lucide-react";
// UPDATED: Points to the New context file to avoid "must be used within a FormProvider" error
import { useFormContext } from "../context/FormContext";
import { formatRegionalTime } from "../components/MobileForm";

function SearchSummary({ onEditClick }) {
  const {
    pickup,
    dropoff,
    pickupDate,
    dropoffDate,
    pickupTime,
    dropoffTime,
    sameLocation,
    driverCountry,
  } = useFormContext();

  // const formatDisplayDate = (dateStr) => {
  //   if (!dateStr) return "Select date";
  //   const date = new Date(dateStr);

  
  //   return date.toLocaleDateString("en-US", {
  //     weekday: "short",
  //     month: "short",
  //     day: "numeric",
  //   });
  // };

  const formatDisplayDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-").map(Number);
    const date = new Date(year, month - 1, day); // local date
    return date.toLocaleDateString("en-US", {
      weekday: "short",
      month: "short",
      day: "numeric",
    });
  };

  const formatDisplayTime = (timeStr) => {
    if (!timeStr) return "Select time";

    // Convert 24-hour format to 12-hour format for display
    const [hours, minutes] = timeStr.split(":");
    const hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    const displayHour = hour === 0 ? 12 : hour > 12 ? hour - 12 : hour;

    return `${displayHour}:${minutes} ${ampm}`;
  };

  const hasDropoff = !sameLocation && dropoff && pickup !== dropoff;

  return (
    <div className="bg-[#122136] shadow-premium sticky top-[64px] z-40 mt-8">
      <div className="max-w-7xl mx-auto px-6 py-4">
        {/* Desktop Layout - Single Row */}
        <div
          className={`hidden lg:flex items-center w-full ${hasDropoff ? "justify-between" : "justify-start gap-24"
          }`}
        >
          {/* Data Group: Changed 'flex-1' to 'flex-initial' and added a gap-8 */}

          {/* Locations */}
          <div className="flex items-center gap-4 min-w-0">
            <div className="flex items-center gap-2 whitespace-nowrap">
              <MapPin className="w-5 h-5 text-gold shrink-0" />
              <span className="text-sm font-heading font-bold text-white tracking-wide">
                {pickup || "Select pickup location"}
              </span>
            </div>

            {/* Conditionally Render Divider and Second Location */}
            {!sameLocation && dropoff && pickup !== dropoff && (
              <>
                <div className="w-1 h-1 bg-white/20 rounded-full shrink-0"></div>
                <div className="flex items-center gap-2 whitespace-nowrap">
                  <MapPin className="w-5 h-5 text-gold shrink-0" />
                  <span className="text-sm font-heading font-bold text-white tracking-wide">
                    {dropoff || "Select dropoff location"}
                  </span>
                </div>
              </>
            )}
          </div>

          {/* Date and Time Group */}
          <div className="flex items-center gap-6 shrink-0 ml-4">
            <div className="flex items-center gap-2 whitespace-nowrap">
              <Calendar className="w-4 h-4 text-gold shrink-0" />
              <span className="text-[13px] font-heading font-bold text-white/90">
                {formatDisplayDate(pickupDate)} -{" "}
                {formatDisplayDate(dropoffDate)}
              </span>
            </div>

            <div className="flex items-center gap-2 border-l border-white/10 pl-6 whitespace-nowrap">
              <Clock className="w-4 h-4 text-gold shrink-0" />
              <span className="text-[13px] font-heading font-bold text-white/90">
                {/* {formatRegionalTime(pickupTime, driverCountry)} -{" "}
                 {" "}
                  {formatRegionalTime(dropoffTime, driverCountry)} */}
                {formatRegionalTime(pickupTime, driverCountry)} -{" "}
                {formatRegionalTime(dropoffTime, driverCountry)}
              </span>
            </div>
          </div>

          {/* Edit Button: Pushed to the right using ml-auto */}
          <button
            onClick={onEditClick}
            className="ml-auto flex items-center gap-2 bg-[#1A2A46] text-white px-3 py-2.5 rounded-xl border border-white/10 transition-all hover:bg-[#2C5282] shadow-premium group shrink-0"
          >
            <Edit className="w-4 h-4 text-gold group-hover:scale-110 transition-transform" />
            <span className="text-xs font-heading font-extrabold uppercase tracking-widest">
              Edit
            </span>
          </button>
        </div>

        {/* Mobile Layout - Stacked */}
        <div className="lg:hidden">
          <div className="flex items-center justify-between mb-3">
            <div className="flex-1">
              <div className="flex items-center gap-2 mb-2">
                <MapPin className="w-4 h-4 text-gold shrink-0" />
                <span className="text-sm font-bold text-white">
                  {pickup || "Select pickup location"}
                </span>
              </div>

              {!sameLocation && (
                <div className="flex items-center gap-2">
                  <MapPin className="w-4 h-4 text-gold shrink-0" />
                  <span className="text-sm font-bold text-white">
                    {dropoff || "Select dropoff location"}
                  </span>
                </div>
              )}
            </div>

            {/* MOBILE FORM CALLED HERE */}
            <button
              onClick={onEditClick} // <--- Make sure this is exactly like this
              className="p-3 bg-[#1A2A46] rounded-xl text-gold shadow-lg border border-white/10"
            >
              <Edit className="w-4 h-4" />
            </button>
          </div>

          <div className="flex items-center gap-4 text-[10px] text-white/50 uppercase tracking-widest font-bold">
            <div className="flex items-center gap-1 whitespace-nowrap">
              <Calendar className="w-3 h-3 text-gold shrink-0" />
              <span>

                {formatDisplayDate(pickupDate)} -{" "}
                {formatDisplayDate(dropoffDate)}
              </span>
            </div>
            <div className="flex items-center gap-1 whitespace-nowrap">
              <Clock className="w-3 h-3 text-gold shrink-0" />
              <span>
                {formatDisplayTime(pickupTime)} -{" "}
                {formatDisplayTime(dropoffTime)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SearchSummary;
